/**
 * @generated SignedSource<<1a30416df06552dc883af21987d875aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadMessages_Query$variables = {
  initialMessageCount?: number | null | undefined;
  recipientId?: string | null | undefined;
  threadId?: string | null | undefined;
};
export type ChatThreadMessages_Query$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_User">;
  } | null | undefined;
  readonly recipient: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_Recipient">;
  } | null | undefined;
  readonly thread: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_Thread">;
  } | null | undefined;
};
export type ChatThreadMessages_Query = {
  response: ChatThreadMessages_Query$data;
  variables: ChatThreadMessages_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "initialMessageCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recipientId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "threadId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "recipientId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "threadId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProfileFeedback",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatContact",
  "kind": "LinkedField",
  "name": "chatContact",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "self",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    }
  ],
  "type": "ChatBot",
  "abstractKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isRecipient"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "initialMessageCount"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadMessages_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatThreadMessages_User"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "recipient",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatThreadMessages_Recipient"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "thread",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "initialMessageCount",
                "variableName": "initialMessageCount"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ChatThreadMessages_Thread"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChatThreadMessages_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unconfirmedEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integrationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "recipient",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "User",
                "abstractKey": null
              },
              (v13/*: any*/)
            ],
            "type": "Recipient",
            "abstractKey": "__isRecipient"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "thread",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purpose",
                "storageKey": null
              },
              {
                "alias": "messagesNotFromSelf",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "excludeSelf": true
                    }
                  }
                ],
                "concreteType": "ChatMessageConnection",
                "kind": "LinkedField",
                "name": "chatMessages",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": "chatMessages(filters:{\"excludeSelf\":true})"
              },
              {
                "alias": "unreadMessages",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "unread": true
                    }
                  }
                ],
                "concreteType": "ChatMessageConnection",
                "kind": "LinkedField",
                "name": "chatMessages",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": "chatMessages(filters:{\"unread\":true})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "recipient",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v13/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "ChatMessageConnection",
                "kind": "LinkedField",
                "name": "chatMessages",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatMessageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "generatedByAi",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JobApplicationEvaluation",
                            "kind": "LinkedField",
                            "name": "jobApplicationEvaluation",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobApplication",
                                "kind": "LinkedField",
                                "name": "jobApplication",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Job",
                                    "kind": "LinkedField",
                                    "name": "job",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "slug",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "sender",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  (v5/*: any*/),
                                  (v10/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "type": "User",
                                "abstractKey": null
                              },
                              (v17/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "ChatThreadMessages_chatMessages",
                "kind": "LinkedHandle",
                "name": "chatMessages"
              }
            ],
            "type": "ChatThread",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31fad63b1df576f990c6bfe12296b0ef",
    "id": null,
    "metadata": {},
    "name": "ChatThreadMessages_Query",
    "operationKind": "query",
    "text": "query ChatThreadMessages_Query(\n  $threadId: ID\n  $recipientId: ID\n  $initialMessageCount: Int\n) {\n  currentUser {\n    ...ChatThreadMessages_User\n    id\n  }\n  recipient: optionalNode(id: $recipientId) {\n    __typename\n    ...ChatThreadMessages_Recipient\n    id\n  }\n  thread: optionalNode(id: $threadId) {\n    __typename\n    ...ChatThreadMessages_Thread_4jMruS\n    id\n  }\n}\n\nfragment ChatMessage_Message on ChatMessage {\n  id\n  label\n  createdAt\n  message\n  ...ChatThreadItem_ChatMessage\n  sender {\n    __typename\n    ...ChatThreadItem_Contact\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadItem_ChatMessage on ChatMessage {\n  id\n  deletedAt\n  editedAt\n  label\n  generatedByAi\n  jobApplicationEvaluation {\n    id\n    jobApplication {\n      job {\n        slug\n        id\n      }\n      id\n    }\n  }\n  sender {\n    __typename\n    ... on User {\n      self\n      firstName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ChatThreadItem_Contact on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    name\n  }\n  ... on ChatBot {\n    name\n  }\n  ...RecipientAvatar_Recipient\n  ...chat_useContactDescription\n}\n\nfragment ChatThreadMessages_Messages_3mhE3E on ChatThread {\n  chatMessages(first: $initialMessageCount) {\n    totalCount\n    edges {\n      node {\n        id\n        ...ChatMessage_Message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ChatThreadMessages_Recipient on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    firstName\n    isProfileFeedback\n  }\n  ... on ChatBot {\n    name\n  }\n  ...ChatThreadItem_Contact\n}\n\nfragment ChatThreadMessages_Thread_4jMruS on ChatThread {\n  id\n  purpose\n  messagesNotFromSelf: chatMessages(filters: {excludeSelf: true}) {\n    totalCount\n  }\n  unreadMessages: chatMessages(filters: {unread: true}) {\n    totalCount\n  }\n  recipient {\n    __typename\n    ...ChatThreadMessages_Recipient\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...ChatThreadMessages_Messages_3mhE3E\n}\n\nfragment ChatThreadMessages_User on User {\n  email\n  unconfirmedEmail\n  integrationName\n  ...user_useIsGuest\n}\n\nfragment RecipientAvatar_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    ...UserAvatarContainer_User\n  }\n  ... on ChatBot {\n    name\n    avatarUrl\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment chat_useContactDescription on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    chatContact {\n      description\n      id\n    }\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment chat_useOnlineStatus on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    self\n    lastSeenAt\n  }\n  ... on ChatBot {\n    __typename\n  }\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n"
  }
};
})();

(node as any).hash = "da2dffed65116d5d7b8eeab2463da033";

export default node;
